import React from 'react';
import { v4 as UUID } from 'uuid';
import { DropdownProps } from '../../../../types';
import { NestedDropdownItem } from '../NestedDropdownItem';
import { SimpleDropdownItem } from '../SimpleDropdownItem';
import styles from './Dropdown.module.scss';

export const Dropdown = ({ dropdownItems }: DropdownProps) => {
    return (
        <ul
            className={styles.dropdown}
            aria-label="submenu"
            data-testid="global-nav-dropdown"
        >
            {dropdownItems.map(
                ({ dropdownItems, text, path, iconType, textColor }) =>
                    dropdownItems ? (
                        <NestedDropdownItem
                            text={text}
                            path={path}
                            iconType={iconType}
                            dropdownItems={dropdownItems}
                            key={UUID()}
                        />
                    ) : (
                        <SimpleDropdownItem
                            text={text}
                            path={path}
                            iconType={iconType}
                            key={UUID()}
                            textColor={textColor}
                        />
                    ),
            )}
        </ul>
    );
};
